import { px } from '@adsk/alloy-react-helpers';

import { AIWrapperDesignTokens, AlloyLegacyThemeDesignTokens } from '../types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = WeaveTheme['tokens'];

export const getAIWrapperTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): AIWrapperDesignTokens => {
  const aiColor = theme.tokens.colors.background.accent.three.bold.value;

  return {
    icon: {
      color: aiColor,
      right: px(theme.spacing.M),
    },
    wrapped: {
      'padding-right': px(theme.spacing.XL),
      color: aiColor,
      'caret-color': aiColor,
    },
  };
};

export const getAIWrapperTokensWeave = (
  tokens: WeaveTokens,
): AIWrapperDesignTokens => {
  const semantic = tokens?.semantic;
  const generic = tokens?.generic;
  const aiColor = semantic?.['text-color']?.ai;

  return {
    icon: {
      color: aiColor,
      right: generic?.spacing?.[16],
    },
    wrapped: {
      'padding-right': generic?.spacing?.[32],
      color: aiColor,
      'caret-color': aiColor,
    },
  };
};
